/* RESPONSIBLE TEAM: team-inbox */
import Model, { attr } from '@ember-data/model';

export default class CancellationQuestionResponse extends Model {
  @attr() appId;
  @attr() adminId;
  @attr('array') reasonIds;
  @attr() comment;
}
